import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { StringMatchChip } from '../StringMatchChip/StringMatchChip';
export const GetAgreementNameChipTID = (parentTestId)=>getTestIds(parentTestId);
export const AgreementNameChip = (param)=>{
    let { testId, predicate, onChange } = param;
    const { AgreementNameChipTestIds } = useMemo(()=>GetAgreementNameChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    return /*#__PURE__*/ _jsx(StringMatchChip, {
        testId: testId,
        predicate: predicate,
        onChange: onChange,
        labels: {
            contains: (value)=>t.agreementNameContains({
                    value
                }),
            fuzzy: (value)=>t.agreementNameFuzzy({
                    value
                }),
            exact: (value)=>t.agreementNameExact({
                    value
                }),
            startsWith: (value)=>t.agreementNameStartsWith({
                    value
                }),
            empty: ()=>t.agreementNameLabel()
        },
        biNames: {
            edit: 'drafts_ai_search_chip_edit_agreement_name',
            apply: 'drafts_ai_search_chip_apply_agreement_name',
            remove: 'drafts_ai_search_chip_remove_agreement_name'
        },
        popoverTestIds: {
            EditPopover: AgreementNameChipTestIds.EditPopover(),
            EditTextField: AgreementNameChipTestIds.EditTextField(),
            ApplyButton: AgreementNameChipTestIds.ApplyButton()
        }
    });
};
